@file:OptIn(InternalResourceApi::class)

package ctdev.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ctdev.composeapp.generated.resources/"

@delegate:ResourceContentHash(470_159_096)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(717_461_464)
internal val Res.drawable.ic_github: DrawableResource by lazy {
      DrawableResource("drawable:ic_github", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_github.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_570_338_805)
internal val Res.drawable.ic_linkedin: DrawableResource by lazy {
      DrawableResource("drawable:ic_linkedin", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_linkedin.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-737_895_613)
internal val Res.drawable.ic_medium: DrawableResource by lazy {
      DrawableResource("drawable:ic_medium", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_medium.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-640_420_288)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-420_501_395)
internal val Res.drawable.phone_mockup: DrawableResource by lazy {
      DrawableResource("drawable:phone_mockup", setOf(
        ResourceItem(setOf(), "${MD}drawable/phone_mockup.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_353_276_838)
internal val Res.drawable.webctbg: DrawableResource by lazy {
      DrawableResource("drawable:webctbg", setOf(
        ResourceItem(setOf(), "${MD}drawable/webctbg.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("ic_github", Res.drawable.ic_github)
  map.put("ic_linkedin", Res.drawable.ic_linkedin)
  map.put("ic_medium", Res.drawable.ic_medium)
  map.put("logo", Res.drawable.logo)
  map.put("phone_mockup", Res.drawable.phone_mockup)
  map.put("webctbg", Res.drawable.webctbg)
}
